import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoFonteRecursoService } from '../services/projeto-fonte-recurso.service';

@Injectable({
  providedIn: 'root'
})
export class ProjetoFonteRecursoResolver implements Resolve<boolean> {

  constructor(private service: ProjetoFonteRecursoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}